import { useParams } from 'react-router-dom';
import UserHeader from './components/user-header/user-header';
import { UserTabs } from './components/user-tabs';
import Loader from '@shared/components/reusables/loader';
import memberApi from '@shared/services/member-api';

const SingleUser = () => {
  const { userId } = useParams();
  const { data: userData, isLoading } = memberApi.useFetchOne({ id: userId });

  if (isLoading) return <Loader />;

  if (!userData) return null;

  return (
    <div className='bg-white'>
      <div className='px-4 py-6'>
        <UserHeader member={userData} />
      </div>
      <UserTabs />
    </div>
  );
};

export default SingleUser;
